import { useStorage } from '@vueuse/core'
import { cloneDeep, isNil } from 'lodash'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import { ROUTE_NAMES } from '@/routes/route-helpers'
import { isLocalStorageAvailable } from '@/utils/persist'
import { createExpirationTimestamp, isTimestampExpired } from '@web-app/utils/stores-timestamp'

const DEFAULT_SWITCH_ORGANIZATION_STATE = {
  organizationId: null,
  expiry: null
}

export const useSwitchOrganization = () => {
  const switchOrganizationState = isLocalStorageAvailable()
    ? useStorage('switch-organization-store', cloneDeep(DEFAULT_SWITCH_ORGANIZATION_STATE))
    : ref(cloneDeep(DEFAULT_SWITCH_ORGANIZATION_STATE))

  const route = useRoute()

  const setState = (newState = DEFAULT_SWITCH_ORGANIZATION_STATE) => {
    switchOrganizationState.value = cloneDeep(newState)
  }

  if (
    route &&
    route.name === ROUTE_NAMES.WEB_APP_SWITCH_ORGANIZATION &&
    route.params.organizationId
  ) {
    setState({
      organizationId: route.params.organizationId,
      expiry: createExpirationTimestamp()
    })
  }

  const resetSwitchOrganizationState = () => setState(DEFAULT_SWITCH_ORGANIZATION_STATE)

  const validateSwitchOrganizationState = () => {
    const isOrganizationIdExist = !isNil(switchOrganizationState.value.organizationId)

    const isValid =
      isOrganizationIdExist && !isTimestampExpired(switchOrganizationState.value.expiry)

    if (!isValid) {
      resetSwitchOrganizationState()
    }

    return isValid
  }

  return {
    switchOrganizationState,
    resetSwitchOrganizationState,
    validateSwitchOrganizationState
  }
}
